module.exports = __webpack_public_path__ + "img/thumbnail_AfricanCrestedPorcupine_f_normal.91575f95.png";